import WarnUnsavedChangesInsideApp from '~/components/warningUnsavedChanges/warnUnsavedChangesInsideApp'
import useWarningUnsavedChangesOnAppClose from '~/components/warningUnsavedChanges/warnUnsavedChangesOutsideApp'
import { sessionStore } from '~/store'

function WarningUnsavedChanges() {
  const showWarning = sessionStore((state) => state.UIElements.showWarning)
  useWarningUnsavedChangesOnAppClose({ shouldDisplayWarning: showWarning })

  return <WarnUnsavedChangesInsideApp shouldDisplayWarning={showWarning} />
}
export default WarningUnsavedChanges
